import { Box, Typography } from "@mui/material";
import inactiveUserLogo from "../../images/inactive_user_logo.png";

const UnProvisionedUser = () => {
  return (
    <Box
      sx={{
        p: 10,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        gap: "20px",
      }}
    >
      <img
        src={inactiveUserLogo}
        alt="Account is inactive"
        style={{ width: 200, marginBottom: "20px" }}
      />
      <Typography variant="h5">
        Your account is neither provisioned nor registered.
      </Typography>
      <Typography variant="body1">
        Please check with the concerned team to register and provision your
        access.
      </Typography>
    </Box>
  );
};

export default UnProvisionedUser;
